import * as React from 'react';
import { DEFAULT_DETAILS_CONTEXT, HotelDetailsContext } from './HotelDetails.context';
import { hotelDetailsReducer } from './HotelDetailsReducer';
export function HotelDetailsProvider({ children }) {
    const [state, dispatch] = React.useReducer(hotelDetailsReducer, Object.assign({}, DEFAULT_DETAILS_CONTEXT));
    const contextValue = React.useMemo(() => ({ state, dispatch }), [state, dispatch]);
    return React.createElement(HotelDetailsContext.Provider, { value: contextValue }, children);
}
